import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 
import './LoginPage.css';

function LoginPage() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(""); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");


    try {
      const res = await axios.post("https://api.memofacdz.com/api/auth/login", formData);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.user.role);
      localStorage.setItem("username", res.data.user.username);
      localStorage.setItem("premium", res.data.premium);
      // REDIRECTION DIFFÉRENCIÉE
      const userRole = res.data.user.role;

      if (userRole === "admin") {
    // Si c'est l'admin, on l'envoie vers la gestion
      navigate("/add-memoire");
      } else {
    // Si c'est un utilisateur simple, on l'envoie vers la bibliothèque de mémoires
      navigate('/'); 
      }
    } catch (err) {
      setError(err.response?.data?.message || "Identifiants invalides ou serveur hors ligne.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card glass-card">
        
        <div className="card-header-nav">
          <span onClick={() => navigate('/')} className="back-home-link">
            ← Retour à l'accueil
          </span>
        </div>

        <h2>Connexion à MémoFac</h2>

        <form className="login-form" onSubmit={handleSubmit}>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email"
              name="email" 
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label htmlFor="password">Mot de passe</label>
            <input 
              type={showPassword ? "text" : "password"} 
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button 
              type="button" 
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '38px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#555',
                padding: '5px'
              }}
            >
              {/* No icons or emojis here now */}
            </button>
          </div>

          {error && <p className="error-message">{error}</p>}

          <button 
            type="submit" 
            className="cta-button login-button-submit" 
            disabled={loading}
          >
            {loading ? "Connexion en cours..." : "Se connecter"}
          </button>
          
          <p className="toggle-auth-text">
            Vous n'avez pas un compte ? <span onClick={() => navigate('/signup')} className="auth-link">Inscrivez-vous</span>
          </p>
          
        </form>
      </div>
    </div>
  );
}

export default LoginPage; 